import React, { useState, useEffect } from 'react';

import apiRequest from 'utils/api/apiRequest';
import BaseModal from 'jsx/elements/modals/BaseModal';
import Button from 'jsx/elements/buttons/Button';
import Spinner from 'jsx/elements/spinner';
import Warning from 'jsx/elements/messages/Warning';
import { useWindowSize } from 'jsx/hooks';
import { useLocale } from './../../components/special/LanguageProvider';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export default ({ form, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [initialData, setInitialData] = useState(null);
  const [showSubmissionError, setShowSubmissionError] = useState(false);

  const { t } = useLocale();
  const { height } = useWindowSize();

  useEffect(() => {
    apiRequest(`${BASE_URL}/admin/form/formdata/${form.formID}`).then(res => {
      if (res && !res.error) {
        setFormData(res);
        setInitialData(res);
      }
    });
  }, []);

  function saveChanges() {
    setShowSubmissionError(false);
    setLoading(true);
    const options = {
      method: 'post',
      data: {
        formID: form.formID,
        name: formData.name,
        data: formData.data
      }
    };
    apiRequest(`${BASE_URL}/admin/form/formdata/save`, options).then(res => {
      if (res && res.error) {
        setLoading(false);
        setShowSubmissionError(true);
      } else {
        onSuccess();
        onClose();
      }
    });
  }

  function updateData(data) {
    setFormData({ ...formData, data });
  }

  const isDirty = initialData && initialData.data !== formData.data;
  const disableSubmit = !isDirty || loading;

  return (
    <BaseModal isOpen={form.formID !== null} onCloseClick={onClose}>
      {!formData && (
        <div style={{ padding: 40 }}>
          <h2>{form.name}</h2>
          <Spinner center />
          <hr />
        </div>
      )}
      {formData && (
        <React.Fragment>
          <div style={{ padding: '20px 20px 0 20px' }} className="form">
            {showSubmissionError && (
              <Warning
                messageType="error"
                messageHeader={t('admin_textchanges_updateFailed', form.name)}
              />
            )}
            <h2>{formData.name}</h2>
          </div>
          <hr />
          {loading && <Spinner center />}
          <div style={{ padding: '0 20px', marginBottom: 40, marginTop: -10 }}>
            <div className="form" style={{ height: '100%', maxHeight: height * 0.7 }}>
              <textarea
                onChange={e => updateData(e.target.value)}
                style={{ minHeight: height * 0.7 - 150 }}
                value={formData.data}
                disabled={loading}
              />
            </div>
          </div>
          <hr />
          <div style={buttonGroupStyle}>
            <div style={{ marginRight: 20 }}>
              <Button
                color="clear"
                text={t('admin_textchanges_cancelButtonText')}
                onClick={onClose}
                disabled={loading}
              />
            </div>
            <Button
              text={t('admin_textchanges_saveButtonText')}
              disabled={disableSubmit}
              onClick={isDirty ? saveChanges : null}
            />
          </div>
        </React.Fragment>
      )}
    </BaseModal>
  );
};

const buttonGroupStyle = {
  padding: 20,
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginTop: -30
};
